import classNames from 'classnames'

import { T, useTranslate } from 'lib/tolgee'
import { numberUtils, TOLGEE_GLOBALS } from 'utils'
import './index.scss'

const TOLGEE_PREFIX = 'VideoCard-LivePostMetric'
const LIVE_METRIC_TRANSLATION = {
  finished: TOLGEE_GLOBALS.views,
  inProgress: TOLGEE_GLOBALS.watching,
  scheduled: TOLGEE_GLOBALS.watching,
}

function LivePostMetric({ live, views }) {
  const t = useTranslate()

  if (!live) {
    return null
  }

  function getMetric() {
    if (live?.state === 'finished') {
      return views
    }

    return live?.performance?.[lastPerformanceIndex]?.concurrentViewers
  }

  const metricTranslation = LIVE_METRIC_TRANSLATION?.[live?.state]
  const isScheduled = live?.state === 'scheduled'
  const lastPerformanceIndex = live?.performance?.length - 1
  const watchingMetric = getMetric()

  return (
    <div
      className={classNames('VideoCard-LivePostMetric', {
        'tooltipped tooltipped-multiline tooltipped-s': isScheduled,
      })}
      aria-label={t({
        key: `${TOLGEE_PREFIX}-warningTooltip`,
        defaultValue: 'The number of people watching will be available here once the live starts.',
      })}
    >
      <strong>{isScheduled ? '--' : numberUtils.format(watchingMetric, 1)}</strong>

      <span>
        <T keyName={metricTranslation.key}>{metricTranslation.defaultValue}</T>
      </span>
    </div>
  )
}

export default LivePostMetric
